/* cf-delivery-header-fix.js
 * Click Fencing - the quote breakdown headed a category "Perth Metro Delivery"
 * while its only line item was "Free Pickup from our Canning Vale Warehouse".
 * Reported by Pete 2026-08-28. Blade hardcodes the heading; glass already
 * switches it correctly.
 * Rule: if every line in a breakdown category is a pickup line, the heading
 * must read "Pickup". Delivery categories with real delivery lines are left
 * untouched, so choosing delivery at quote review still reads correctly.
 * Display only - no price, product, quantity or cart line is changed.
 */
(function () {
  if (window.__cfDeliveryHeaderPatched) return;
  window.__cfDeliveryHeaderPatched = true;

  function apply() {
    var cats = document.querySelectorAll('.breakdown-category, .breakdown-section');
    for (var i = 0; i < cats.length; i++) {
      try {
        var head = cats[i].querySelector('.category-header h5, .category-header h4, h5, h4');
        if (!head) continue;
        var title = head.textContent.trim();
        if (!/deliver/i.test(title)) continue;
        var names = cats[i].querySelectorAll('.item-name');
        if (!names.length) continue;
        var allPickup = true;
        for (var j = 0; j < names.length; j++) {
          if (!/pick\s*-?\s*up/i.test(names[j].textContent)) { allPickup = false; break; }
        }
        if (allPickup && title !== 'Pickup') head.textContent = 'Pickup';
      } catch (e) {}
    }
  }

  var queued = false;
  function schedule() { if (queued) return; queued = true; (window.requestAnimationFrame || setTimeout)(function () { queued = false; apply(); }, 0); }

  try {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  } catch (e) {}
  // Permanent safety net, deliberately not time-limited. Verified 2026-08-28 on blade:
  // flipping the gate hinge side redraws the preview into a BRAND NEW <svg>, and the
  // MutationObserver did not fire a pass that caught it - the drawing showed hinges on
  // the left while the annotation still read the old right-hand geometry. A single DOM
  // poke fixed it instantly, so the work is right and only the trigger was missed. The
  // pass is a few querySelectorAll calls over a small subtree, so running it for the
  // life of the page costs nothing and a customer can sit on this page for minutes.
  setInterval(apply, 1200);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  apply();
  console.log('[cf-delivery-header-fix] installed');
})();
